import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Variant = 'gold' | 'red' | 'ghost';

type CasinoButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  fullWidth?: boolean;
};

const variantMap: Record<Variant, string> = {
  gold: 'btn-casino',
  red: 'btn-casino btn-casino-red',
  ghost: 'btn-casino btn-casino-ghost',
};

export const CasinoButton = forwardRef<HTMLButtonElement, CasinoButtonProps>(
  ({ variant = 'gold', fullWidth, className, type = 'button', ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(variantMap[variant], fullWidth && 'w-full', className)}
        {...rest}
      />
    );
  },
);
CasinoButton.displayName = 'CasinoButton';
